"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLOUDINARY_CLOUD_NAME = exports.CATALOG_IMAGE_TRANSFORMS = exports.CATALOG_IMAGE_SOURCES = void 0;
exports.catalogImageUrl = catalogImageUrl;
exports.catalogImagePublicId = catalogImagePublicId;
exports.CATALOG_IMAGE_SOURCES = [
    'qvet',
    'buscada',
    'alternativa',
    'manual',
];
/**
 * Las transformaciones, **medidas contra Cloudinary**, no elegidas de memoria.
 *
 * Las tres llevan tres cosas, y cada una está por una medición distinta:
 *
 * **1 · `e_trim` primero, en su propio paso.** Recorta el marco de color uniforme que traen
 * casi todas las fotos de producto. Medido sobre 12 al azar el 2026-09-07: **10 de 12 mejoran**,
 * y varias muchísimo — un artículo pasó de ocupar el **31 % del recuadro al 100 %**, otro del
 * 45 % al 100 %. Sin él, el producto flota en un mar de blanco y **es exactamente lo que se veía
 * mal en la ficha**.
 *
 * ⚠️ **Va separado por `/`, como paso propio.** En el mismo grupo que `c_pad,w_160,h_160`,
 * `e_trim` gana y la salida deja de ser cuadrada (`136x97` en vez de `160x160`), con lo que la
 * columna de la tabla se descuadra. Encadenado, **10 de 10 salen cuadrados exactos**.
 *
 * **2 · `f_auto,q_auto` siempre.** Sin ellos —como decía el handoff original, sólo
 * `c_fit,w_640`— un PNG grande sale casi entero: 6 artículos pesaban **1.030 KB sin ellos y
 * 266 KB con ellos, un 74 % menos**. Uno pasó de 382 KB a 44 KB.
 *
 * **3 · `c_pad,b_auto` en las cuadradas**, que rellena con el color del borde en vez de
 * recortar, para que un bote alto y una caja ancha queden alineados en la misma columna. Del
 * catálogo, **el 87 % son casi cuadradas** y sólo 22 pierden más de la mitad del recuadro.
 *
 * La ficha **no** es cuadrada: usa `c_fit` y quien la pinta le fija el alto y deja el ancho
 * libre. Ahí sí importan los extremos — el 125 es de 328×936, o sea 1:2,85, y metido en un
 * cuadrado se quedaba en 34 px de ancho dentro de 96.
 */
exports.CATALOG_IMAGE_TRANSFORMS = {
    lista: 'e_trim/f_auto,q_auto,c_pad,b_auto,w_160,h_160',
    ficha: 'e_trim/f_auto,q_auto,c_fit,w_640',
    // `c_limit` y no `c_fit`: **no agranda** una foto pequeña. `c_fit` sí, y ampliar el 125
    // —de 328 px de ancho— a 1.400 sólo produce un borrón grande.
    completa: 'e_trim/f_auto,q_auto,c_limit,w_1400,h_1400',
    qvet: 'e_trim/f_auto,q_auto,c_pad,b_auto,w_760,h_760',
};
/** La cuenta de Cloudinary de HVP. La misma que sirve las fotos de colaboradores. */
exports.CLOUDINARY_CLOUD_NAME = 'dwalcv9li';
/**
 * Construye la URL de una variante. Función pura: no lee configuración ni entorno.
 *
 * Se deja `cloudName` como parámetro para poder probarla y por si algún día hay otra cuenta,
 * pero en la práctica nadie lo pasa.
 */
function catalogImageUrl(image, variant, cloudName = exports.CLOUDINARY_CLOUD_NAME) {
    const transform = exports.CATALOG_IMAGE_TRANSFORMS[variant];
    // Cloudinary sirve igual con extensión o sin ella, pero pedirla explícita evita que
    // `f_auto` tenga que adivinar cuando el navegador no manda `Accept`.
    const extension = image.format ? `.${image.format}` : '';
    // La versión rompe la caché de 30 días al cambiar la foto. Ver {@link CatalogItemImage.version}.
    const version = image.version ? `v${image.version}/` : '';
    return `https://res.cloudinary.com/${cloudName}/image/upload/${transform}/${version}${image.publicId}${extension}`;
}
/**
 * El `publicId` que le corresponde a un artículo. Las 923 ya subidas siguen este patrón, así
 * que subir otra vez **sustituye** en vez de duplicar.
 */
function catalogImagePublicId(qvetCode) {
    return `hvp/catalog/${qvetCode}`;
}
